export const GPAYUPIQRDetailsPopUp = ({ cancelbtn, heading }) => {
    return (
        <>
            <div className="modal fade show"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                style={{
                    display: "flex", alignItems: 'center', justifyContent: 'center', backgroundColor: "#00000090",
                    zIndex: 99999, position: 'fixed', left: 0, right: 0, bottom: 0, overflow: 'hidden'
                }}>
                <div className="modal-dialog" role="document"
                    style={{
                        minWidth: '35%', height: '90vh', maxHeight: '90vh'
                    }}
                >
                    <div className="modal-content" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <div className="modal-header">
                            <h5 className="card-title fw-bold green pt-1" style={{ paddingLeft: '10px' }} id="exampleModalLongTitle">{heading}</h5>
                            <button onClick={() => cancelbtn()} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body examination mx-0" style={{ overflowY: 'auto', flex: 1, overflow: 'hidden' }}>
                            <div className="row">
                                <div className="col-12 text-center">
                                    {/* <span>
                                        <img
                                            src="/Static/Assets/img/QR.jpeg"
                                            alt="QR Code"
                                            style={{ height: '60vh', width: 'auto', display: 'inline-block' }}
                                        />
                                    </span> */}

                                    <div
                                        style={{
                                            height: "60vh",
                                            width: "auto",
                                            backgroundImage: "url('/Static/Assets/img/QR.jpeg')",
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "center",
                                            backgroundSize: "contain",
                                        }}
                                    ></div>

                                </div>

                                <hr className="mt-2" style={{ color: 'gray' }} />
                                <div className="row text-center">
                                    <div className="col-12">
                                        {/* <button
                                            type='button'
                                            onClick={cancelbtn}
                                            className="w-80 btn addbtn btn-success  m-2 px-4" data-ktwizard-type="action-next">
                                            <i class="fa-solid fa-floppy-disk pe-1"></i> Submit
                                        </button> */}
                                        <button
                                            type="button"
                                            onClick={cancelbtn}
                                            className="w-80  btn addbtn btn-danger  m-2 px-4" data-ktwizard-type="action-next">
                                            <i class="fa-solid fa-xmark pe-1"></i> Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}